<template>
  <div id="pageContent">
    <div id="formArea" class="borderBox">
     <ul>
       <OperatorMenu  v-for="(group, index) in scriptGroup" :key="index" :scriptItem="group" :scriptID="scriptID"></OperatorMenu>
     </ul>
      <hr>
      <p>Редактирование: {{getScriptNameByID(scriptID)}}</p>
      <editScript :parentID="'0'" :scriptID="scriptID"></editScript>
    </div>
    <div class="borderBox" id="operatorScript">
      <OperatorScriptLayout :parentID="'0'" :sourceId="scriptID"></OperatorScriptLayout>
    </div>
  </div>
</template>

<script>
  import {mapState, mapGetters} from 'vuex';
  export default {
    name: "scriptRouting",
    data(){
      return {
        scriptID:'0'
      }
    },
    components:{
      OperatorScriptLayout: () => import('@/components/OperatorScript/OperatorScriptLayout'),
      OperatorMenu:()=>import('@/components/OperatorScript/adminScriptsMenu'),
      editScript:()=>import('@/components/OperatorScript/editScript')
    },
    methods:{
      loadOperatorScript:function () {
          this.$myApi.scriptContent()
          .then((result)=>{
            this.$store.dispatch('setScripts',result)})
          .catch((msg)=>{console.log(msg)});
      },
    },
    computed:{
      ...mapState({
        scriptGroup:state=>state.operatorScripts.scriptsGroup
      }),
      ...mapGetters(['getScriptNameByID']),
    },
    watch:{
      $route(to) {
        this.scriptID = to.params.id;
        this.$store.dispatch('loadScriptById',this.scriptID).catch((res)=>alert(res));
      }
    },
    mounted(){
      if(this.$route.params.id != undefined) {
        this.scriptID = String(this.$route.params.id);
        this.$store.dispatch('loadGetRefsScript')
        .then(()=>{this.$store.dispatch('loadScriptById',this.scriptID)})
        .catch((res)=>alert(res));
        // this.loadOperatorScript();
      } else {
        alert('Ошибка в ссылке');
      }
    }
  }
</script>

<style scoped>
  #headOutgoing{align-items: center;text-align: left;padding: 0 0 20px;}
  #headOutgoing p {margin: 0;padding: 0;}
  #pageContent{display: flex;align-items: flex-start;justify-content: flex-start;width: 100%;}
  #formArea{width: 900px;}

  .loaderWrap{min-height: 66vh;height: 1px;}
  #operatorScript{    margin: 0;
    width: calc(100% - 1070px);
    text-align: left;
    position: fixed;
    top: 10px;
    right: 10px;
    height: calc(100vh - 40px);
    overflow-x: scroll;}
  #startCall{margin-top: 30px;}
  .callingBox{justify-content: flex-start;align-items: center}
  .callingBox .button{border: 6px solid;border-top:12px solid;margin: 0 10px}
  ul{list-style: none;text-align: left}

  @media screen and (max-width: 1600px) {
    #pageContent{
      display: flex;
      flex-direction: column-reverse;
      justify-content: flex-end;
    }
    #operatorScript{
      margin: 10px 0 10px 90px;
      width: 900px;
      position: relative;
      top:0;
      right:0;
      height: auto;
      overflow: inherit;
    }
  }
</style>
